import {
  Box,
  Container,
  Typography,
  Grid,
  TextField,
  Button,
} from "@mui/material";
import { useState } from "react";
import toast from "react-hot-toast";
import authimg from "../../assests/authimg.png";
import { useAuthStore } from "../../store/useAuthStore";
import { Link, useNavigate } from "react-router-dom";


const Login = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const naviagte = useNavigate()
  const { login } = useAuthStore()

  const handleLogin = async () => {

    if (!email || !password) {
      toast.error("Email and Password is Required");
      return

    }
    // console.log(email, password)
    const res = await login(email, password)
    if (res) {
      naviagte(-1)
    }
  }

  return (
    <Box sx={{ padding: "40px 0 60px" }}>
      <Container maxWidth="xl">
        <Grid
          container
          sx={{ width: "100%" }}
          columnSpacing={{ xs: 1, sm: 2, md: 2 }}
        >
          <Grid item size={{ xs: 12, sm: 12, md: 7 }}>
            <Box
              sx={{
                padding: "20px 80px 0px 0",
                "& img": {
                  maxWidth: "100%",
                  display: "block",
                },
              }}
            >
              <img src={authimg} alt="auth-image" />
            </Box>
          </Grid>
          <Grid
            item
            size={{ xs: 12, sm: 12, md: 5 }}
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: "36px",
                  lineHeight: "30px",
                  fontWeight: "700",
                  fontFamily: `"Quicksand", sans-serif`,
                  color: "#000",
                  "& span": {
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: "400",
                    fontFamily: `"Lato", sans-serif`,
                    display: "block",
                  },
                }}
              >
                Log in to Exclusive
                <span>Enter your details below</span>
              </Typography>
              <Box
                component="form"
                sx={{
                  marginTop: "30px",
                  "& label": {
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: "400",
                    fontFamily: `"Lato", sans-serif`,
                    color: "#000",
                  },
                  "& .MuiFormControl-root": {
                    width: "100%",
                  },
                  "& input::placeholder": {
                    color: "#999999",
                  },
                }}
                noValidate
                autoComplete="off"
              >
                <TextField
                  id="standard-basic"
                  label="Email or Phone Number"
                  type="email"
                  name="email"
                  value={email}
                  onChange={(ele) => setEmail(ele.target.value)}
                  variant="standard"
                />
                <TextField
                  id="standard-basic"
                  label="Password"
                  type="password"
                  name="password"
                  value={password}
                  onChange={(ele) => setPassword(ele.target.value)}
                  variant="standard"
                />

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "30px",
                    "& a": {
                      fontSize: "16px",
                      lineHeight: "24px",
                      marginLeft: "30px",
                    },
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      display: "block",
                      textAlign: "center",
                      background: "#008BFF",
                      width: "143px",
                      height: {
                        xs: "36px",
                        sm: "36px",
                        md: "45px",
                        lg: "56px",
                      },
                      borderRadius: "4px",
                      color: "#FAFAFA",
                      boxShadow: "none",
                      fontFamily: `"Quicksand", sans-serif`,
                      fontWeight: 500,
                      fontSize: {
                        xs: "12px",
                        sm: "15px",
                        md: "15px",
                        lg: "16px",
                      },
                      lineHeight: {
                        xs: "18px",
                        sm: "20px",
                        md: "22px",
                        lg: "24px",
                      },
                      textTransform: "capitalize",
                    }}
                    onClick={handleLogin}
                  >
                    Login
                  </Button>
                  <a href="/login">Forget Password?</a>
                </Box>
                <Box 
                sx={{
                  fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: "400",
                    fontFamily: `"Lato", sans-serif`,
                    color: "#000",
                    margin:"30px 0 30px",
                    textAlign:"center",
                    position:"relative",
                    "& hr":{
                      position:"absolute",
                      top:"22%",
                      width:"100%",
                      zIndex:"1",
                    },
                    "& div":{
                      width:"30px",
                      background:"#fff",
                      margin:"0 auto",
                      position:"relative",
                      zIndex:"2",
                    },
                }}>
                 <div>OR</div>
                  <hr/>
                </Box>
                 <Button 
                 component={Link}
                   to="/signup"
                    variant="contained"
                    sx={{
                      display: "flex",
                      textAlign: "center",
                      background: "transparent",
                      border:"1px solid #008BFF",
                      color:"#008BFF",
                      width: "100%",
                      height: {
                        xs: "36px",
                        sm: "36px",
                        md: "45px",
                        lg: "56px",
                      },
                      borderRadius: "4px",
                      // color: "#FAFAFA",
                      boxShadow: "none",
                      fontFamily: `"Quicksand", sans-serif`,
                      fontWeight: 500,
                      fontSize: {
                        xs: "12px",
                        sm: "15px",
                        md: "15px",
                        lg: "16px",
                      },
                      lineHeight: {
                        xs: "18px",
                        sm: "20px",
                        md: "22px",
                        lg: "24px",
                      },
                      textTransform: "capitalize",
                    }}
                  >
                   Sign up
                  </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Login;
